var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoaded)?_c('Loader'):_vm._e(),(_vm.user.email)?_c('Header',{attrs:{"fit20":this._data,"signOut":_vm.signOut}}):_vm._e(),(_vm.user.email)?_c('Admin',{attrs:{"selectTab":_vm.selectTab,"fit20":this._data,"saveBlock":_vm.saveBlock,"cancelEditing":_vm.cancelEditing}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }